import 'reflect-metadata';

export interface TranslationMeta {
    model: string;
    idField?: string;
    field?: string;
}

export const TranslationMetadataKey = Symbol('translation-metadata');

export function Translatable(metadata: TranslationMeta) {
    return function (target: Object, propertyKey: string | symbol) {
        Reflect.defineMetadata(TranslationMetadataKey, metadata, target, propertyKey);
    };
}
